module.exports = __webpack_public_path__ + "img/IMG_9512_L_Foamcore_MockedUp.2afae96b.jpg";